'use strict';

$(function() {
    $('.form__locator__search').on('submit', function(event) {
        event.preventDefault();
        
        var keywordValue = $('.locator__search').val();
        
        // Encode the keyword value to replace spaces with %20
        var encodedKeyword = encodeURIComponent(keywordValue);

        var newUrl = $(this).attr('action') + '?keyword=' + encodedKeyword;
        window.location.href = newUrl;
    });
});
